import { render, staticRenderFns } from "./DetailedView.vue?vue&type=template&id=47812504&"
import script from "./DetailedView.vue?vue&type=script&lang=js&"
export * from "./DetailedView.vue?vue&type=script&lang=js&"
import style0 from "./DetailedView.vue?vue&type=style&index=0&id=47812504&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports